import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LandingComponent } from './landing/landing.component';
import { LayoutComponent } from './theme/layout/layout.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/theme/view/horizontal/dark',
    pathMatch: 'full'
  },
  /*{
    path: 'landing',
    component: LandingComponent
  },*/
  {
    path: 'theme',
    component: LayoutComponent,
    children: [
      {
        path: 'view/:layout/:type',
        loadChildren: () => import('./view/view.module').then(module => module.ViewModule)
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
